import React from 'react'
import debounce from 'debounce'

import {
  _getSearchEnterprise
} from '../../../services'

import {
  Input,
  Button,
  Icon,
  Modal
} from 'antd'

const defaultState = {
  enterprises: [],
  loading: false,
  modalVisible: false,
  selectedEnterprise: false,
  hideDropdown: true,
  searchTerm: ""
}

class EnterpriseSelector extends React.Component {

  state = defaultState

  render(){

    const dropDownStyles = {
      padding: "4px 8px",
      background: "white",
      position: "absolute"
    }

    return (
      <div>
        <style dangerouslySetInnerHTML={{__html: `
          .dropdown {
            background: #fff;
            position: absolute;
            width: 100%;
            z-index: 2;
            box-shadow: 0 2px 8px rgb(0 0 0 / 9%);
          }

          .dropdown-container {
            position: relative;
          }

          .dropdown-row {
            padding: 8px 12px;
            border-bottom: 1px solid #e8e8e8;
            cursor: pointer;
          }
        
        `}}/>
        <Modal
          okText="Confirm"
          title={"Attach Enterprise Prices"}
          closable={false}
          visible={this.state.modalVisible}
          onCancel={this.closeModal}
          onOk={this.handleOk}
        >
          <div className="dropdown-container">
            <Input
              value={this.state.searchTerm}
              placeholder="Enterprise Name"
              onChange={(e)=>{
                this.setState({ loading: true, searchTerm: e.target.value })
                this.doDebouncedSearch(e.target.value)
              }}
            />
            {this.state.loading?
            <div className="dropdown">
              <div className="dropdown-row">
                Loading...
              </div>  
            </div>
            :
            this.state.enterprises.length > 0 && 
            !this.state.hideDropdown &&
            <div className="dropdown">
              {this.state.enterprises.map( enterprise => {
                return (
                  <div
                  onClick={()=>this.handleSelect(enterprise)}
                  className="dropdown-row">
                    {enterprise.companyName}
                  </div>
                )
              })}
            </div>}
          </div>
        </Modal>
        <Button
          type="primary"
          onClick={this.openModal}
        >
          <Icon type="plus"/>
          {this.props.text}
        </Button>
      </div>
    )
  }

  componentDidMount(){
    this.doDebouncedSearch = debounce(this.doDebouncedSearch, 300)
  }

  doDebouncedSearch = (searchTerm) => {
    this.setState({ loading: true, hideDropdown: false }, () => {
      this.handleSearch(searchTerm)
    })
  }

  closeModal = () => {
    this.setState(defaultState)
  }

  openModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleOk = () =>{
    this.setState({
      modalVisible: false
    }, () => {
      this.props.onSelect(this.state.selectedEnterprise)
    })
  }

  handleSelect = (enterprise) => {
    this.setState({
      hideDropdown: true,
      selectedEnterprise: enterprise,
      searchTerm: enterprise.companyName
    })
  }

  handleSearch = (searchTerm) => {

    if (!searchTerm || searchTerm.length == 0){
      return this.setState({
        loading: false,
        enterprises: []
      })
    }

    _getSearchEnterprise({ searchTerm, limit: 6})
    .then( res => {
      const {enterprises} = res.data
      this.setState({
        loading: false,
        enterprises
      })
    })

  }
}

export default EnterpriseSelector


// WEBPACK FOOTER //
// ./src/components/quotation/add-quotation-modal/enterprise-selector.js